import { Base } from '@studiometa/js-toolkit';

/**
 * Homepage class.
 */
export default class Search extends Base {
  /**
   * Class config
   * @type {object}
   */
  static config = {
    name: 'Search',
    refs: ['btn', 'close', 'input', 'searchPanel'],
  };

  /**
   * Define body element
   * @returns {void}
   */
  mounted() {
    this.body = document.querySelector('body');
  }

  /**
   * Click on loupe
   * @returns {void}
   */
  onBtnClick() {
    this.openSearch();
  }

  /**
   * Click on cross
   * @returns {void}
   */
  onCloseClick() {
    this.closeSearch();
  }

  /**
   * Open Search Panel
   * @returns {void}
   */
  openSearch() {
    this.body.classList.add('search-menu-is-open');
    this.$refs.input.focus();
  }

  /**
   * Close Search Panel
   * @returns {void}
   */
  closeSearch() {
    this.body.classList.remove('search-menu-is-open');
  }
}
